import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import { LangProvider } from "./lib/i18n";
import { AuthProvider, Protected } from "./lib/auth";
import { AppShell } from "./components/AppShell";
import Login from "./pages/Login";
import AuthCallback from "./pages/AuthCallback";
import MyCard from "./pages/MyCard";
import AdminPage from "./pages/AdminPage";
import Insights from "./pages/Insights";
import PublicCard from "./pages/PublicCard";

function App() {
  return (
    <LangProvider>
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/c/:slug" element={<PublicCard />} />
            <Route path="/login" element={<Login />} />
            <Route path="/login/owner" element={<Login backup />} />
            <Route path="/auth/google" element={<AuthCallback />} />
            <Route element={<Protected><AppShell /></Protected>}>
              <Route path="/me" element={<MyCard />} />
              <Route path="/insights" element={<Insights />} />
              <Route path="/admin" element={<Protected anyPerm={["employees.view", "settings.fields", "roles.manage", "templates.manage", "settings.branding", "reports.view", "translations.manage", "audit.view", "wallet.manage", "settings.notifications"]}><AdminPage /></Protected>} />
            </Route>
            <Route path="*" element={<Navigate to="/me" replace />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-center" richColors />
      </AuthProvider>
    </LangProvider>
  );
}

export default App;
